import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import { CONNECT, INTEGRATIONS_PATH, SETTINGS, SHOPIFY_PATH } from '../constants';
import IntegrationCard from '../IntegrationCard';
import withShopifySettings from '../../../../products/products/Shopify/withShopifySettings';
import shopifyIcon from '../../../../../../images/shopifyIcon.png';
import { SHOPIFY_MATCHES } from '../../../../products/products/Shopify/constants';

const ShopifyIntegrationCard = (
  {
    baseUrl,
    shopifyConnectionState,
    loadingShopifySettings,
  }
) => {
  const shopifyIntegrationPath = `${baseUrl}${INTEGRATIONS_PATH}${SHOPIFY_PATH}/`;

  return (
    <IntegrationCard
      connectionLink={`${shopifyIntegrationPath}${CONNECT}`}
      description={t('settings:integrations.shopify.description')}
      imageSrc={shopifyIcon}
      isConnected={shopifyConnectionState === SETTINGS || shopifyConnectionState === SHOPIFY_MATCHES}
      loading={loadingShopifySettings}
      settingsLink={`${shopifyIntegrationPath}${SETTINGS}`}
      title={t('settings:integrations.shopify.title')}
    />
  );
};

ShopifyIntegrationCard.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  loadingShopifySettings: PropTypes.bool.isRequired,
  shopifyConnectionState: PropTypes.string.isRequired,
};

export default compose(
  withShopifySettings,
)(ShopifyIntegrationCard);
